import React, { FC, useEffect, useState } from 'react'
import { IonModal, IonHeader, IonFooter, IonContent } from '@ionic/react'
import { observer } from 'mobx-react'
import { restaurantCenter, restaurantConfig } from 'restaurant'
import { memberMobx, themeMobx } from '@mobxStore'
import StyleItem from './style'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  resolve?: () => void;
  reject?: () => void;
}

const DisplayModeModal: FC<IProps> = (props) => {
  const { resolve, reject } = props
  const { memberExtra } = memberMobx
  const [mode, setMode] = useState<string>(memberExtra.displayMode)
  const modeArr: any[] = [
    {
      label: i18n.t('mkt.setting.waterfall'),
      value: 'waterfall'
    },
    {
      label: i18n.t('mkt.setting.list'),
      value: 'list'
    },
    {
      label: i18n.t('mkt.setting.classic'),
      value: 'classic'
    },
  ]
  const sureChange = (val: string) => {
    memberMobx.updateMemberInfo({
      extra: {
        displayMode: val,
      }
    }).then(() => {
      setMode(val)
      // setState 在合成事件和钩子函数中是异步的
      restaurantCenter.setConfig({
        displayMode: val as any,
      })
      resolve && resolve()
    })
  }
  const changeAuto = (e: any) => {
    if (mode === '') return
    memberMobx.updateMemberInfo({
      extra: {
        displayMode: '',
      }
    }).then(() => {
      setMode('')
      restaurantCenter.setConfig({
        displayMode: themeMobx.data.showTheStyle === 0 ? 'waterfall' : themeMobx.data.showTheStyle === 1 ? 'list' : 'classic'
      })
      resolve && resolve()
    })
  }
  return (
    <IonModal
      cssClass='display-mode-modal'
      isOpen
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span className='title'>{i18n.t('mkt.setting.foodDisplayStyle')}</span>
        <div className='right' onClick={reject}>
          <i className='iconfont icon-close'></i>
        </div>
      </IonHeader>
      <IonContent className='modal-content'>
        <div className='mode-list'>
          {
            modeArr.map((item: any) => (
              <div key={item.value} className='mode-item' onClick={() => sureChange(item.value)}>
                <StyleItem type={item.value} selected={item.value === mode} />
                <div className='name'>
                  <span>{item.label}</span>
                </div>
                <div className={`radio-item ${item.value === mode && 'select'}`}>
                  {item.value === mode && <i className='iconfont icon-check'></i>}
                </div>
              </div>
            ))
          }
        </div>
      </IonContent>
      <IonFooter>
        <div className='modal-footer'>
          <div className='auto-area'>
            <div>
              <div className='title'>{i18n.t('mkt.setting.autoChoose')}</div>
              <div className='des'>{i18n.t('mkt.setting.autoChooseDes')}</div>
            </div>
            <div className={`radio-item ${mode === '' && 'select'}`} onClick={changeAuto}>
              {mode === '' && <i className='iconfont icon-check'></i>}
            </div>
          </div>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(DisplayModeModal)
